import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Heart, ArrowLeft, Loader2 } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { Loader, PassionBadge, GhostButton } from "@/components/ui-bits";

export default function ProjectDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setP(null); api.get(`/projects/${id}`).then((r) => setP(r.data)); }, [id]);
  const like = async () => {
    setBusy(true);
    const { data } = await api.post(`/projects/${id}/like`);
    setP((x) => ({ ...x, liked: data.liked, like_count: data.like_count }));
    setBusy(false);
  };
  if (!p) return <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"><Loader /></div>;
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <Link to="/explore" className="inline-flex items-center gap-1.5 text-sm text-[#55708F] hover:text-[#FF6B00] mb-5"><ArrowLeft className="h-4 w-4" />Explore</Link>
      <div className="rounded-3xl overflow-hidden"><img src={fileUrl(p.image)} alt={p.title} className="w-full max-h-[520px] object-cover" /></div>
      <div className="mt-6">
        <PassionBadge slug={p.passion} />
        <h1 className="text-3xl font-extrabold tracking-tight text-[#071126] mt-3">{p.title}</h1>
        <div className="flex items-center justify-between mt-4">
          <Link to={`/u/${p.author?.id}`} className="flex items-center gap-3">
            <img src={fileUrl(p.author?.avatar)} alt="" className="h-11 w-11 rounded-full object-cover" />
            <div><p className="text-xs text-[#55708F]">Created by</p><p className="font-semibold text-[#071126]">{p.author?.name}</p></div>
          </Link>
          <GhostButton onClick={like} disabled={busy} data-testid="like-project-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Heart className={`h-4 w-4 ${p.liked ? "fill-[#FF6B00] text-[#FF6B00]" : ""}`} />}{p.like_count}</GhostButton>
        </div>
        <p className="text-[#071126]/70 leading-relaxed mt-6 whitespace-pre-wrap">{p.description}</p>
      </div>
    </div>
  );
}
